import React from "react";
import CapsuleImageVertical from "../CapsuleImageVertical/CapsuleImageVertical";
import SectionTwoImage from "../../Assets/Images/ab-2.svg";
import SectionTwoImageMobile from "../../Assets/Images/ab-mobile-img-2.png";
import wardsImage from "../../Assets/Images/wards-logo.svg";
import { useTranslation } from "../../Hooks/useTranslation"; // Import the hook

const Ward = () => {
  const translations = useTranslation(); // Get translations dynamically
  return (
    <>
      <div className="flex-1">
        <div className="hidden lg:block">
          <CapsuleImageVertical image={SectionTwoImage} />
        </div>
        <div className="mt-8 mb-4 lg:hidden flex justify-center animate__animated animate__fadeIn">
          <img
            src={SectionTwoImageMobile}
            alt="section-two-image-mobile"
            className="w-full"
          />
        </div>
      </div>

      <div className="flex-1 mt-2 lg:mt-32 animate__animated animate__fadeIn  lg:pl-0 px-4">
        <h3 className="md:text-[24px] font-semibold mb-4 text-[16px] leading-[20px]  md:leading-[28px] extra-title36">
          {translations.valuesWardsTitle}
        </h3>
        <p className="text-[14px] leading-[22px] mb-4 text-justify extra-para-vs">
          {translations.valuesWardsDescription1}
        </p>
        <p
          className="text-[14px] leading-[22px] mb-4 text-justify extra-para-vs"
          dangerouslySetInnerHTML={{
            __html: translations.valuesWardsDescription2,
          }}
        ></p>
        {
          <img
            src={wardsImage}
            className="max-w-[150px] max-h-[150px] hidden lg:block"
            alt="awards-logo"
          />
        }
      </div>
    </>
  );
};

export default Ward;
